"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledNoData = exports.StyledPagination = exports.StyledTableCell = exports.StyledTableRow = exports.StyledTable = exports.StyledTableSection = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const polished_1 = require("polished");
const variants_1 = require("./../../themes/variants");
exports.StyledTableSection = styled_components_1.default.section.withConfig({
    shouldForwardProp: (prop) => !["centered"].includes(prop),
}) `
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
  width: 100%;
  ${({ centered }) => {
    return (centered &&
        (0, styled_components_1.css) `
        align-items: center;
        justify-content: center;
      `);
}}
`;
exports.StyledTable = styled_components_1.default.table.withConfig({
    shouldForwardProp: (prop) => !["variant", "outlined"].includes(prop),
}) `
  ${(props) => {
    const { theme, outlined } = props;
    const thTextColor = (0, variants_1.variantTextColor)(props);
    const thBgColor = (0, variants_1.variantBgColor)(props);
    const tdBgColor = (0, polished_1.lighten)(0.22, (0, variants_1.variantTextColor)({ theme, variant: "disabled" }));
    return (0, styled_components_1.css) `
      width: 100%;
      position: relative;
      border-spacing: 0.125rem;
      height: fit-content;
      & > thead {
        position: sticky;
        top: 0;
        line-height: 1.5;
        & > tr > th {
          text-align: left;
          padding: 0.5rem;
          background-color: ${outlined ? thBgColor : thTextColor};
          color: ${outlined ? thTextColor : thBgColor};
          border: 0.03rem solid ${outlined ? tdBgColor : thBgColor};

          &:first-child {
            border-top-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
          }
        }
      }
    `;
}}
`;
exports.StyledTableRow = styled_components_1.default.tr.withConfig({
    shouldForwardProp: (prop) => !["clickable", "selected"].includes(prop),
}) `
  ${(props) => {
    const { theme, onClick, selected } = props;
    const tdBgColor = selected
        ? (0, polished_1.lighten)(0.491, (0, variants_1.variantTextColor)(props))
        : (0, polished_1.lighten)(0.22, (0, variants_1.variantTextColor)({ theme, variant: "disabled" }));
    return (0, styled_components_1.css) `
      background-color: ${tdBgColor};
      ${!selected &&
        `&:hover {
        background-color: ${(0, variants_1.variantBgColor)(props)};
      }`}

      ${onClick &&
        (0, styled_components_1.css) `
        cursor: pointer;
      `}

      & > td {
        max-width: 33vh;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        vertical-align: top;
        & p {
          margin: 0;
        }

        & > td > p {
          margin: 0.25rem 0rem;
        }
      }
    `;
}}
`;
exports.StyledTableCell = styled_components_1.default.th.withConfig({
    shouldForwardProp: (prop) => !["align", "width", "padding"].includes(prop),
}) `
  & {
    ${(props) => {
    const { align = "left", width, padding } = props;
    return (0, styled_components_1.css) `
        text-align: ${align}!important;
        ${width &&
        `
          width:${width}!important;
          min-width:${width}!important;
          `}
        ${padding && `padding:${padding}!important;`}
      `;
}}
  }
`;
exports.StyledPagination = styled_components_1.default.section `
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
exports.StyledNoData = styled_components_1.default.section `
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
//# sourceMappingURL=styled.js.map